/**
 * @generated SignedSource<<0116b654c3b163dc00056b8a42406962>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useSyncAppleDeveloperAgreementsForAllBrandsMutation$variables = {};
export type useSyncAppleDeveloperAgreementsForAllBrandsMutation$data = {
  readonly syncAppleDeveloperAgreementsForAllBrands: ReadonlyArray<{
    readonly appleDeveloperAgreementsPendingSince: any | null;
    readonly id: string;
    readonly showIosTosAlert: boolean;
  }>;
};
export type useSyncAppleDeveloperAgreementsForAllBrandsMutation = {
  response: useSyncAppleDeveloperAgreementsForAllBrandsMutation$data;
  variables: useSyncAppleDeveloperAgreementsForAllBrandsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BrandType",
    "kind": "LinkedField",
    "name": "syncAppleDeveloperAgreementsForAllBrands",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appleDeveloperAgreementsPendingSince",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "showIosTosAlert",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSyncAppleDeveloperAgreementsForAllBrandsMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useSyncAppleDeveloperAgreementsForAllBrandsMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f9951f537234ac271a78bfc48d71cd01",
    "id": null,
    "metadata": {},
    "name": "useSyncAppleDeveloperAgreementsForAllBrandsMutation",
    "operationKind": "mutation",
    "text": "mutation useSyncAppleDeveloperAgreementsForAllBrandsMutation {\n  syncAppleDeveloperAgreementsForAllBrands {\n    id\n    appleDeveloperAgreementsPendingSince\n    showIosTosAlert\n  }\n}\n"
  }
};
})();

(node as any).hash = "c7bfb49868faaa8a92f295166f0cdcf7";

export default node;
